import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { searchProducts, getSearchSuggestions } from "../../api/search"
import { addProducts } from "./productSlice"



const initialState = {

  // results stored by query
  queries: {
    /*
      query: {
        pages: {
          1: [product_ids],
          2: [product_ids]
        }
      }
    */
  },

  suggestions: {
    categories: [],
    collections: [],
    subcollections: [],
    products: []
  },

  loading: false,
  suggestionsLoading: false,
  error: null

}



/////////////////////////////////////////////////////
// FETCH SEARCH PRODUCTS
/////////////////////////////////////////////////////

export const fetchSearchProducts = createAsyncThunk(

  "search/fetchSearchProducts",

  async ({ query, page = 1 }, thunkAPI) => {

    const { dispatch } = thunkAPI

    try {

      const res = await searchProducts(query, page)

      const products = res.data.data.products || []

      // store full products
      dispatch(addProducts(products))

      return {
        query,
        page,
        products
      }

    } catch (error) {

      return thunkAPI.rejectWithValue(error.response?.data)

    }

  }

)



/////////////////////////////////////////////////////
// FETCH SEARCH SUGGESTIONS
/////////////////////////////////////////////////////

export const fetchSearchSuggestions = createAsyncThunk(

  "search/fetchSearchSuggestions",

  async (query, thunkAPI) => {

    try {

      const res = await getSearchSuggestions(query)

      return res.data.data || {}

    } catch (error) {

      return thunkAPI.rejectWithValue(error.response?.data)

    }

  }

)



/////////////////////////////////////////////////////
// SLICE
/////////////////////////////////////////////////////

const searchSlice = createSlice({

  name: "search",

  initialState,

  reducers: {

    clearSearchError: (state) => {

      state.error = null

    },


    clearSuggestions: (state) => {

      state.suggestions = {
        categories: [],
        collections: [],
        subcollections: [],
        products: []
      }

    }

  },



  /////////////////////////////////////////////////////
  // EXTRA REDUCERS
  /////////////////////////////////////////////////////

  extraReducers: (builder) => {

    builder



      //////////////////////////////////////////////////
      // SEARCH PRODUCTS
      //////////////////////////////////////////////////

      .addCase(fetchSearchProducts.pending, (state) => {

        state.loading = true
        state.error = null

      })


      .addCase(fetchSearchProducts.fulfilled, (state, action) => {

        state.loading = false

        const { query, page, products } = action.payload

        const ids = products.map(p => p.public_id || p.id)



        if (!state.queries[query]) {

          state.queries[query] = {
            pages: {}
          }

        }


        if (!state.queries[query].pages[page]) {

          state.queries[query].pages[page] = []

        }


        ids.forEach(id => {

          if (!state.queries[query].pages[page].includes(id)) {

            state.queries[query].pages[page].push(id)

          }

        })

      })


      .addCase(fetchSearchProducts.rejected, (state, action) => {

        state.loading = false
        state.error = action.payload?.message

      })



      //////////////////////////////////////////////////
      // SEARCH SUGGESTIONS
      //////////////////////////////////////////////////

      .addCase(fetchSearchSuggestions.pending, (state) => {

        state.suggestionsLoading = true

      })


      .addCase(fetchSearchSuggestions.fulfilled, (state, action) => {

        state.suggestionsLoading = false

        state.suggestions = {
          categories: action.payload.categories || [],
          collections: action.payload.collections || [],
          subcollections: action.payload.subcollections || [],
          products: action.payload.products || []
        }

      })


      .addCase(fetchSearchSuggestions.rejected, (state, action) => {

        state.suggestionsLoading = false
        state.error = action.payload?.message

      })

  }

})



/////////////////////////////////////////////////////
// EXPORT ACTIONS
/////////////////////////////////////////////////////

export const {
  clearSearchError,
  clearSuggestions
} = searchSlice.actions



/////////////////////////////////////////////////////
// EXPORT REDUCER
/////////////////////////////////////////////////////

export default searchSlice.reducer